<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-04-11 09:43:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-02 17:44:18
-->
<template>
  <div class="box">
    <div>
      <g-img :src="src" :size="widthData" :color="'#888'"></g-img>
    </div>
    <div v-if="title" class="txt-box c-sub-txt">
      {{ title }}
    </div>
    <div v-if="btnTxt" class="btn-box">
      <van-button :color="$store.state.tc" @click="btnClick">{{
        btnTxt
      }}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "GNoContent",
  props: {
    title: {
      type: [String, Number],
      default: "",
    },
    btnTxt: {
      type: String,
      default: "",
    },
    widthData: {
      type: [String, Number],
      default: 300,
    },
  },
  data() {
    return {
      src: require("@/assets/images/noCard.png"),
    };
  },
  created() {},
  mounted() {},
  methods: {
    btnClick() {
      this.$emit("btnClick");
    },
  },
};
</script>
<style scoped lang="scss">
.box {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  /* margin: 0 auto; */
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  div {
    /* text-align: center; */
    margin: 0 auto;
  }
  .txt-box {
    margin-top: 50px;
  }
  .btn-box {
    margin-top: 50px;
  }
}
</style>
